import axios from 'axios'
import qs from 'qs'
import Cookies from 'js-cookie'
import store from '@/store/index'
// import { Message } from 'iview/dist/iview.js'
import { Message } from 'at-ui'
// import { Message } from 'view-design';
// import iView from

// axios 配置
axios.defaults.timeout = 500000
axios.defaults.baseURL = process.env.BASE_URL || ''


export function url_domain() {
    return ""
    // return process.env.NODE_ENV === 'production' ? 'https://demo-mc.CCPay.com' : ''
    // return "http://127.0.0.1:3001"
}

export function url_pre() {
    return "/v1"
}

// POST传参序列化
axios.interceptors.request.use((config) => {
    const token = Cookies.get("OTC919-token");
    // console.log(token)
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    if (config.url.indexOf("_thisisjson_") > 0) {
        config.url = config.url.replace("_thisisjson_", "");
        config.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    } else {
        if (config.method === 'post') {
            config.data = qs.stringify(config.data)
        }
        config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }

    return config
}, (error) => {
    return Promise.reject(error)
})
// 返回状态判断
axios.interceptors.response.use((res) => {
    // console.log(store().getters.curLoginUser.token);
    if (res.status === 200) {

        // console.log(store);
        const dataAxios = res.data
        // 这个状态码是和后端约定的
        const { code } = dataAxios
        // 根据 code 进行判断
        if (code === undefined) {
            // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
            return dataAxios
        } else {
            // 有 code 代表这是一个后端接口 可以进行进一步的判断
            switch (code) {
                case 0:
                    // [ 示例 ] code === 0 代表没有错误
                    // if (res.data.meta) {
                    //     return { dataAxios, pagination: res.data.meta.pagination }
                    // }
                    return dataAxios;
                case 1:
                    Message.info(dataAxios.msg);
                    new Error(res);
                    throw dataAxios.msg
                // break;
                case 1001:
                    // Message({
                    //     message: dataAxios.msg,
                    //     type: 'info',
                    //     duration: 5 * 1000
                    // })
                    store().commit("setLogin", undefined)
                    // 跳转路由
                    // vm.$router.push("/login?ref=" + vm.$route.query.ref)
                    // return dataAxios;
                    // this.$router.push("login");
                    // console.log()
                    window.location.href = "/login?ref=" + location.pathname + location.search;
                    // this.$router.push("/login?ref=" + to.fullPath);
                    break;
                case 1103:
                    // Message({
                    //     message: dataAxios.msg,
                    //     type: 'error',
                    //     duration: 5 * 1000
                    // })
                    new Error(res);
                    // return dataAxios;
                    // this.$router.push("login");
                    // this.$store.commit("setMessageError", dataAxios.msg);
                    break;

                case 1995:
                    //下单失败状态码;
                    break;
                case 401:
                    store().commit("setLogin", undefined)
                    window.location.href = "/login?to=" + location.pathname + location.search;
                    break;
                default:

                    if (parseInt(code) > 10000) {
                        // console.log(dataAxios)
                        // Message.error(dataAxios.msg);
                        return dataAxios
                    }
                    Message.error(dataAxios.msg);
                    // 不是正确的 code
                    // console.log(this);
                    // console.log(store().commit("setMessageError"));

                    // console.log(dataAxios);
                    // Message({
                    //     message: dataAxios.msg,
                    //     type: 'error',
                    //     duration: 3 * 1000
                    // })

                    new Error(res);
                    // return dataAxios;
                    // store.dispatch('setMessageError', dataAxios.msg)
                    // console.log(store().commit("setMessageError",dataAxios.msg));
                    // store().commit("setMessageError", dataAxios.msg);
                    // 不是正确的 code
                    // errorCreat(`${dataAxios.msg}: ${res.config.url}`)
                    // console.log("不是正确的 code -" + dataAxios.msg);
                    // errorCreat(`${dataAxios.msg}: ${response.config.url}`)
                    break;
            }
        }
    } else {
        return Promise.reject(res)
    }
}, (error) => {
    return Promise.reject(error)
})

export function post(url, params) {
    return axios.post(url, params);
}

export function postJson(url, params) {
    return axios.post(url + "_thisisjson_", params);
}

export function get(url) {
    return axios.get(url);
}
